import http from '../api/axios';

export const loginApi = (params) => {
    return http.post('/api/user/login', params);
};
export const registerApi = (params) => {
    return http.post('/api/user/register', params);
};
export const logoutApi = () => {
    return http.post('/api/user/logout');
};
export const getUserInfo = (params) => {
    return http.post('/api/user/getUserInfo', params);
};
export const updateUserInfo = (params) => {
    return http.post('/api/user/update', params);
};
export const uploadAvatar = (params) => {
    return http.post('/api/upload/upload', params);
}


// WEBPACK FOOTER //
// ./src/api/login.js